import React from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idSubCategoriesUpdate, setPublicOptionSubCategory } from '../../../adminSlice';

export default class InputFormsForSubCategories  extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            userInputId: '',
            userInputContent: '',
           publicSubCategory: false,
          
        }
      
       this.handleUserInputContent = this.handleUserInputContent.bind(this);
       
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
       this.onSave = this.onSave.bind(this);
       this.handleSetPublicOption = this.handleSetPublicOption.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;

        const item = {
            sub_id: this.props.adminState.selectedId,
            sub_name: this.state.userInputContent,
            
        }
        dispatch(idSubCategoriesUpdate(item));  
}
 // CLICK SAVE
onSave() {
        const { dispatch } = this.props;

        const item = {
            subId: this.props.adminState.selectedId,
            publicOption: this.state.publicSubCategory,
            
        }
        console.log(item);
        dispatch(setPublicOptionSubCategory(item));
        this.setState(
        {
           publicSubCategory: false
        }); 
       dispatch(closeInputForms()); 
}
//CHECK PUBLIC
handleSetPublicOption() {
     this.setState(
        {
           publicSubCategory: !this.state.publicSubCategory
        }
    )
}
// ENTER INPUT
handleUserInputContent(e) {
    this.setState(
        {
            userInputContent: e.target.value
        }
    )
}



// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
       return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openInputFormsForSubCategories) {
        return(
            <div className="InputFormsForQuizes">
                <p>Изменить название подкатегории:</p>
                <p className="p-text">id: {this.props.adminState.selectedId}</p>
                <p className="p-text">Старое название: {this.props.adminState.dataSubCategoryId.map(item => {
               //console.log(this.props.adminState.selectedId)
                if (item.id === Number(this.props.adminState.selectedId)){
                    return item.text;
                } else return null;
                //{ console.log(item.text)}
                
                }
                )}
                </p>
                


             
                <form>
                    <label>
                        Введите новое название подкатегории: </label>
                    <input id="content" type="text"  onChange={this.handleUserInputContent} 
                    />
                    


                </form>
                <button onClick={this.onSend}>OK</button>
                <div className="container-row">
                                    <input  className="check-box" type="checkbox" id="checkboxSub"
                                    onChange={this.handleSetPublicOption} 
                                    ></input>
                                    <p>(public)</p>
                </div> 
                <button  onClick={this.onSave}>Сохранить</button>
                <button onClick={this.onClose}>Закрыть</button>
            </div>
        )
     } else return null;
       
     

        
    }
}